import React from 'react'
import { Link } from 'react-router-dom'
import { logout } from '../apis/firebase'
import { useAuth } from '../contexts/AuthContext'


export default function AdminBar() {
  const {user} = useAuth()
  
  if (user) {
    return (
    <nav className='nav-wrapper blue-bg'>
      
      <div className='admin-bar right'>
        <ul className='admin-bar-list'>
          <li><Link className='yellowtext' to='/admin'>Admin dashboard</Link></li>
          <li onClick={() => logout()}>Log out</li>
        </ul>
      </div>
    </nav>
  )
  }
  
}
